export const StepCard: React.FC<{
  step: number;
  title: string;
  children: React.ReactNode;
}> = ({ step, title, children }) => (
  <div className="border rounded-lg p-4 bg-white">
    <div className="font-semibold mb-2 text-gray-900">
      Passo {step} – {title}
    </div>
    {children}
  </div>
);
